import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { UserAcceptancePlannedMaintenance } from './user-acceptance-planned-maintenance';

export class FailureModeUserAcceptance implements ViewModel {
  friendlyTypeNameSingular: string = 'User Acceptance';
  apiRoute: string = null;
  id: string;
  plannedMaintenance: UserAcceptancePlannedMaintenance[] = [];
  userComments: string;
  accepts: boolean;
  isMitigated: boolean;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.userComments = data.userComments;
    this.accepts = data.accepts;
    this.isMitigated = data.isMitigated;

    if (data.plannedMaintenance) {
      this.plannedMaintenance = data.plannedMaintenance.map((details: UserAcceptancePlannedMaintenance) => {
        const newMaintenance = new UserAcceptancePlannedMaintenance();
        newMaintenance.loadFromJson(details);
        return newMaintenance;
      });
    }
  }
}
